import { AnimatedCounter } from './AnimatedCounter';

const WhyChooseUs2 = () => {
  const problems = [
    {
      problem: "Still Entering Data Manually?",
      solution: "We build smart digital systems that eliminate errors, prevent data loss, and make it effortless to record, trace, and manage your information with accuracy.",
      icon: "🚀",
      stat: "100%",
      statLabel: "Easy, Fast & Error-Free Tracking"
    },
    {
      problem: "Outdated Website Hurting Your Brand?",
      solution: "We create modern, responsive websites that reflect your brand's excellence and convert visitors into customers.",
      icon: "🎨",
      stat: "300%",
      statLabel: "Average Traffic Increase"
    },
    {
      problem: "Mobile Experience Frustrating Users?",
      solution: "Every website we build is perfectly optimized for mobile devices, ensuring seamless experience across all platforms.",
      icon: "📱",
      stat: "100%",
      statLabel: "Mobile Responsive"
    },
    {
      problem: "Slow Loading Times Driving Users Away?",
      solution: "We optimize every aspect of your site for speed, ensuring fast load times that keep visitors engaged.",
      icon: "⚡",
      stat: "<2s",
      statLabel: "Average Load Time"
    },
    {
      problem: "No Clear Online Strategy?",
      solution: "We provide comprehensive digital solutions from web design to marketing, all aligned with your business goals.",
      icon: "🎯",
      stat: "24/7",
      statLabel: "Support Available"
    },
    {
      problem: "Budget Concerns Holding You Back?",
      solution: "Transparent pricing with flexible payment options. Premium results without the premium price tag.",
      icon: "💰",
      stat: "50%",
      statLabel: "Cost Savings"
    }
  ];

  return (
    <section id="about" className="w-full py-24 relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30">
            <span className="text-purple-600 text-sm font-semibold">Why Choose RPS Digital</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            We Solve Your <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">Biggest Challenges</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every business faces unique digital challenges. Here's how RPS Digital help you overcome them.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {problems.map((item, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-white to-gray-50 rounded-2xl p-8 border-2 border-gray-100 hover:border-purple-300 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl cursor-pointer"
            >
              {/* Hover Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/0 to-purple-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="relative z-10">
                {/* Icon */}
                <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                
                {/* Problem */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">
                  {item.problem}
                </h3>
                
                {/* Solution */}
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {item.solution}
                </p>
                
                {/* Stat */}
                <div className="flex items-baseline gap-2 pt-4 border-t border-gray-200 group-hover:border-purple-300 transition-colors">
                  <span className="text-3xl font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">
                    <AnimatedCounter value={item.stat} />
                  </span>
                  <span className="text-sm text-gray-500">{item.statLabel}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-2xl p-8 border border-purple-500/30 backdrop-blur-sm">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to Solve Your Business Challenges?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Let's discuss how we can transform your online presence and drive real results for your business.
            </p>
            <button className="px-8 py-4 rounded-full text-white font-semibold text-lg shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group" style={{ backgroundColor: '#D946EF' }}>
              <span className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              <span className="relative flex items-center gap-2">
                Get Started Today
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs2;

